import React, {Component} from 'react';
import PortalToBody from 'react-portal-to-body';
import PopupPlayer from './PopupPlayer';

interface PopupPlayerLinkProps {
    text: string;
    video: {
        /**
         * Vimeo video Id
         */
        id: string,
        /**
         * Aspect ratio width
         */
        width: number,
        /**
         * Aspect ratio height
         */
        height: number,
    };
    downloadUrl?: string;
}

export default class PopupPlayerLink extends Component<PopupPlayerLinkProps> {
    public state: {
        displayPopup: boolean
    };

    public constructor(props: PopupPlayerLinkProps) {
        super(props);
        this.handlePopupOpenClick = this.handlePopupOpenClick.bind(this);
        this.handlePopupCloseClick = this.handlePopupCloseClick.bind(this);
        this.state = {displayPopup: false};
    }

    public render() {
        return <span>
            {/* TODO: React doesn't like 'a' tags with javascript in the href and keeps warning us they will break.  */}
            <a onClick={this.handlePopupOpenClick} href="javascript:void(0)">{this.props.text}</a>
            {this.state.displayPopup &&
            <PortalToBody>
                <PopupPlayer videoId={this.props.video.id}
                             aspectRatio={this.props.video.width + ':' + this.props.video.height}
                             onClose={this.handlePopupCloseClick}
                             downloadUrl={this.props.downloadUrl}/>
            </PortalToBody>
            }
        </span>;
    }

    private handlePopupOpenClick() {
        this.setState({displayPopup: true});
    }

    private handlePopupCloseClick() {
        this.setState({displayPopup: false});
    }
}
